import { render, staticRenderFns } from "./DtEducationViolation.vue?vue&type=template&id=580653ea&"
import script from "./DtEducationViolation.vue?vue&type=script&lang=js&"
export * from "./DtEducationViolation.vue?vue&type=script&lang=js&"
import style0 from "./DtEducationViolation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports